import { normalize, Schema, arrayOf } from 'normalizr';

const productItemNormalizr = new Schema('productItems', {idAttribute: "prdId"});
const productsItemsKeyToArrayOfProductItems = {productItems: arrayOf(productItemNormalizr)};

const shippingMethodNormalizr = new Schema('shippingMethods', {idAttribute: "orgId"});
const shippingMethodsKeyToArrayOfShippingMethods = {shippingMethods: arrayOf(shippingMethodNormalizr)};
const brokerNormalizr = new Schema('brokers', {idAttribute: "orgId"});
const brokerKeyToArrayOfBroker = {brokers: arrayOf(brokerNormalizr)};



const abilitiesNormalizr = new Schema('abilities');
const abilitiesKeyToArrayOfAbilities = {abilities: arrayOf(abilitiesNormalizr)};


const quoteIdAttribute = (entity)=>{
  return entity.quoteId + entity.optionId;
};
const quoteNormalizr = new Schema('quotes', {idAttribute: quoteIdAttribute});
const quotesKeyToArrayOfQuotes = {quotes: arrayOf(quoteNormalizr)};

const asnNormalizr = new Schema('asns');
const asnDetailNormalizr = new Schema('asnDetails');
const asnDetailsKeyToArrayOfAsnDetails = {asnDetails: arrayOf(asnDetailNormalizr)};

const asnShippinigPalletNormalizr = new Schema('asnShippingPallets');
const asnShippingPalletsKeyToArrayOfAsnhippingPallets = {asnShippingPallets: arrayOf(asnShippinigPalletNormalizr)};

const CmrServiceNormalizr = new Schema('cmrServices');
const cmrServicesKeyToArrayOfCmrServices = {cmrServices: arrayOf(CmrServiceNormalizr)};


const cmrDomainsNormalizr = new Schema('cmrDomains');
const cmrDomainsKeyToArrayOfCmrDomains = {cmrDomains: arrayOf(cmrDomainsNormalizr)};


asnNormalizr.define({
  asnDetails: arrayOf(asnDetailNormalizr),
  asnShippingPallets: arrayOf(asnShippinigPalletNormalizr)
})


const asnKeyNormalizr = {asn: asnNormalizr};

export {
  productItemNormalizr, 
  productsItemsKeyToArrayOfProductItems, 
  asnKeyNormalizr,
  cmrServicesKeyToArrayOfCmrServices,
  cmrDomainsKeyToArrayOfCmrDomains,
  shippingMethodsKeyToArrayOfShippingMethods,
  brokerKeyToArrayOfBroker,
  asnDetailsKeyToArrayOfAsnDetails,
  quotesKeyToArrayOfQuotes,
  quoteIdAttribute,
  asnShippingPalletsKeyToArrayOfAsnhippingPallets,
  abilitiesKeyToArrayOfAbilities,

};


// WEBPACK FOOTER //
// ./src/stores/relationships.js